import type { ItemDef } from './types'

/**
 * Magnet (PHASE3 T3.12, D-057): for `durationTicks` the runner collects shards and item boxes
 * whose box centre is within `radiusPx` of its own centre on both axes, as if it touched them
 * (`crate.ts`; the client draws them flying in). A box is still only taken with an empty slot.
 */
export const magnet: ItemDef = {
  id: 'magnet',
  use(world, i) {
    const p = world.players[i]!
    p.magnetUntil = world.tick + world.cfg.items.magnet.durationTicks
  },
}
